import React from 'react';
import PageLayout from 'components/layouts/PageLayout';

const TypePage = () => {
    return (
        <PageLayout title='숙소유형'>
            {/* 여기에 페이지 내용을 추가하세요 */}
        </PageLayout>
    );
};

export default TypePage;
